export default __webpack_public_path__ + "static/media/skewLeft.7fb07759.png";